// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"number-focus_wrapper__CWRkR","number":"number-focus_number__4O08y"};